import React from 'react';
import { Container, Row, Col, Card, Dropdown, Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import './Agenesis.css'; 

function AgenesisApproval() {
    return (
        <Container className="mt-5">
            <h3 className="text-center mb-4">Agenesis Approval</h3>
            <Row>
                <Col md={6}>
                    <Card className="p-3 shadow-box">
                        <h5 className="text-center">Agenesis Allayed List</h5>
                        <div className="d-flex flex-column align-items-center mt-3">
                            <Card className="p-3 w-100 mb-3 shadow-sm">
                                <div className="d-flex align-items-center">
                                    <div className="me-3">
                                        <div
                                            className="rounded-circle bg-secondary"
                                            style={{ width: '50px', height: '50px' }}
                                        ></div>
                                    </div>
                                    <div>
                                        <h6>Name Agenesi</h6>
                                        <p>Detaille</p>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <div>
                                        <p>License</p>
                                        <div
                                            className="bg-secondary d-flex align-items-center justify-content-center"
                                            style={{ width: '80px', height: '60px' }}
                                        >
                                            <i className="bi bi-folder2-open" style={{ fontSize: '1.5rem' }}></i>
                                        </div>
                                    </div>
                                    <Dropdown>
                                        <Dropdown.Toggle id="dropdown-basic" className="custom-dropdown-toggle">
                                            Approve / Reject
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="custom-dropdown-menu">
                                            <Dropdown.Item href="#" className="approve-item">Approve</Dropdown.Item>
                                            <Dropdown.Item href="#" className="reject-item">Reject</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </Card>
                        </div>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card className="p-3 shadow-box">
                        <h5 className="text-center">On Serves</h5>
                        <div className="scrollable-container d-flex flex-column align-items-center mt-3"> {/* Added scrollable-container */}
                            <Card className="p-3 w-100 mb-3 shadow-sm">
                                <div className="d-flex align-items-center">
                                    <div className="me-3">
                                        <div
                                            className="rounded-circle bg-secondary"
                                            style={{ width: '50px', height: '50px' }}
                                        ></div>
                                    </div>
                                    <div>
                                        <h6>Agnes Name</h6>
                                        <p>Detaille</p>
                                    </div>
                                    <Button variant="danger" className="ms-auto">
                                        <FaTrash />
                                    </Button>
                                </div>
                            </Card>
                            {/* Duplicate or additional cards can go here to test the scroll effect */}
                        </div>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default AgenesisApproval;